module.exports = __webpack_public_path__ + "img/ver-todos-color.ce710f1c.svg";